// Pure slice helper for client-side table pagination. Given the full item
// array, a 0-indexed page, and a page size, returns the bounded page plus the
// visible slice and page count. `safePage` clamps an out-of-range page so a
// shrunk dataset never strands the viewer past the last page.
/**
 * @param {Array} items Full dataset (non-arrays treated as empty).
 * @param {number} page Requested 0-indexed page.
 * @param {number} [pageSize=25] Rows per page.
 * @returns {{visibleRows:Array,pageCount:number,safePage:number,totalItems:number}}
 */
export function pageWindow(items, page, pageSize = 25) {
  const arr = Array.isArray(items) ? items : [];
  const totalItems = arr.length;
  const pageCount = Math.max(1, Math.ceil(totalItems / pageSize));
  const safePage = Math.min(Math.max(0, page || 0), pageCount - 1);
  const start = safePage * pageSize;
  return { visibleRows: arr.slice(start, start + pageSize), pageCount, safePage, totalItems };
}

// Compact page-range generator: shows first, last, current ±2, and ellipsis
// where there are gaps. For ≤ 7 pages, returns the full sequence.
export function buildPageRange(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i);
  const keep = new Set([0, total - 1, current, current - 1, current + 1, current - 2, current + 2]);
  const sorted = [...keep].filter((n) => n >= 0 && n < total).sort((a, b) => a - b);
  const out = [];
  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) out.push('…');
    out.push(sorted[i]);
  }
  return out;
}
